// extracted by mini-css-extract-plugin
module.exports = {"container":"OurMission_container___V5OG"};